
const iconCache: Record<string, string> = {};

const availableIcons = [
  'address-book', 'address-card', 'alarm-clock', 'amazon-brands', 'angles-down',
  'angles-left', 'angles-right', 'angles-up', 'app-store-brands', 'apple-pay-brands',
  'arrow-rotate-right', 'audible-brands', 'ban', 'bandcamp-brands', 'bell',
  'bluesky-brands', 'bookmark', 'burst', 'calendar-days', 'camera',
  'cc-amazon-pay-brands', 'cc-amex-brands', 'cc-apple-pay-brands', 'cc-mastercard-brands',
  'cc-paypal-brands', 'cc-stripe-brands', 'cc-visa-brands', 'certificate', 'chart-pie',
  'circle-exclamation', 'circle-half-stroke', 'circle-info', 'circle-minus', 'circle-plus',
  'circle-user', 'circle-xmark', 'clock', 'clone', 'copy', 'credit-card', 'crop-simple',
  'dailymotion-brands', 'discord-brands', 'disqus-brands', 'earth-americas', 'ebay-brands',
  'empire-brands', 'envelope', 'etsy-brands', 'facebook-brands', 'facebook-messenger-brands',
  'file-invoice', 'file-lines', 'file-pen', 'film', 'fire-flame-curved', 'fire',
  'folder-open', 'folder', 'github-brands', 'gitlab-brands', 'google-pay-brands',
  'google-play-brands', 'grip', 'grip-vertical', 'heart', 'id-card', 'image', 'images',
  'instagram-brands', 'intercom-brands', 'itch-io-brands', 'kickstarter-brands',
  'kickstarter-k-brands', 'link', 'linkedin-brands', 'location-arrow', 'location-dot',
  'lock', 'map-location-dot', 'map-location', 'message', 'moon', 'odysee-brands',
  'palette', 'paper-plane', 'patreon-brands', 'paypal-brands', 'photo-film', 'qrcode',
  'rebel-brands', 'receipt', 'reddit-alien-brands', 'reddit-brands', 'reply', 'retweet',
  'share-nodes', 'shopify-brands', 'signal-messenger-brands', 'sliders', 'snapchat-brands',
  'stack-overflow-brands', 'star', 'steam-brands', 'stripe-brands', 'table-list',
  'telegram-brands', 'threads-brands', 'thumbtack', 'tiktok-brands', 'triangle-exclamation',
  'tumblr-brands', 'twitch-brands', 'twitter-brands', 'unlock', 'user-group', 'user',
  'vimeo-v-brands', 'whatsapp-brands', 'wordpress-brands', 'x-twitter-brands', 'youtube-brands'
] as const;

/**
 * Lazy-load an SVG icon from /public/icons/ directory
 * @param name - Icon name (without -solid.svg suffix)
 * @returns Promise resolving to SVG string, or empty string if not found
 */
export async function getIcon(name: string): Promise<string> {
  if (iconCache[name]) {
    return iconCache[name];
  }

  try {
    const response = await fetch(`/icons/${name}-solid.svg`);
    if (!response.ok) {
      console.warn(`Icon not found: ${name}`);
      iconCache[name] = '';
      return '';
    }

    const svgContent = await response.text();
    iconCache[name] = svgContent;
    return svgContent;
  } catch (error) {
    console.error(`Failed to load icon: ${name}`, error);
    iconCache[name] = '';
    return '';
  }
}

export async function preloadIcons(names: string[]): Promise<void> {
  await Promise.all(names.map(name => getIcon(name)));
}

export function getAvailableIcons(): readonly string[] {
  return availableIcons;
}
